module.exports = __webpack_public_path__ + "static/media/history_chuyen_doi.ff52cd72.png";